export function buildComplaintPayload(values) {
    var placeOcurrence = values.complement
        ? "".concat(values.location, " - Complemento: ").concat(values.complement)
        : values.location;
    return {
        category: values.irregularityType,
        description: values.description,
        placeOcurrence: placeOcurrence,
        supplier: {
            name: values.companyName,
            cnpj: values.cnpj ? values.cnpj.replace(/\D/g, "") : undefined,
        },
    };
}
